import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Pagination, Table } from 'antd';
import TableSortedHeader from '../../../components/table_sorted_header/TableSortedHeader';

class TableComponent extends Component {
  handleRouteToFinalReview = (domain) => {
    if (this.props.tableFor === 'usageUrl') {
      return;
    } else if (this.props.redirectPermission) {
      window.open(`/final_review?domainName=${domain}`).focus();
    } else {
      window.open('/403');
    }
  };

  handleChangePage = (page, pageSize) => {
    this.props.onChangePagination(this.props.tableFor, page, pageSize);
  };

  onShowSizeChange = (page, pageSize) => {
    this.props.onChangePagination(this.props.tableFor, page, pageSize);
  };

  showTotal = (total) => {
    return (
      <span>
        Total <b>{this.props.tableData.totalCount}</b> items
      </span>
    );
  };

  prepareTableColumns = () => {
    // let filteredColumns = this.props.tableColumns.filter((tc) =>
    //   _.includes(this.props.selectedFiltersFields, tc.fieldKey)
    // );

    return this.props.tableColumns.map((column) => {
      let sortingOptions = {};
      if (this.props.sortingOptions.hasOwnProperty(column.fieldKey)) {
        sortingOptions = this.props.sortingOptions[column.fieldKey];
      }

      if (column.customSorted) {
        column.title = () => (
          <TableSortedHeader
            headerTitle={column.originTitle}
            sortOptions={sortingOptions}
          />
        );

        column.onHeaderCell = (column) => {
          return {
            onClick: () => {
              this.props.handleChangeColumnSort(this.props.tableFor, column);
            }
          };
        };
      } else {
        column.title = column.originTitle;
      }

      // column.sortOrder = sortOption.type
      return column;
    });
  };

  render() {
    return (
      <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
        <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-25'>
          <Table
            rowKey='id'
            style={{ cursor: 'pointer' }}
            filtered={true}
            bordered
            locale={{
              emptyText: this.props.noDataMsg
                ? this.props.noDataMsg
                : 'No data for the selected filters'
            }}
            // onChange={this.handleColumnSorter}
            // rowSelection={rowSelection}
            // columns={this.props.tableColumns}
            columns={this.prepareTableColumns()}
            pagination={false}
            // rowClassName={this.getRowClassName}
            dataSource={this.props.tableData.content}
            // scroll={{ x: 3200 }}
            scroll={{ x: false }}
            // isFetching={this.props.dataIsFetching}

            onRow={(record, rowIndex) => ({
              onClick: () => {
                this.handleRouteToFinalReview(record.domain);
              }
            })}
            rowSelection={this.props.rowSelection && this.props.rowSelection}
          />
        </div>
        <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
          <Pagination
            hideOnSinglePage
            showQuickJumper
            showTotal={this.showTotal}
            onShowSizeChange={this.onShowSizeChange}
            current={this.props.paginationOptions.pageNumber}
            pageSize={this.props.paginationOptions.pageSize}
            className='mt-4 mb-4 mr-3'
            total={this.props.tableData.totalCount}
            onChange={this.handleChangePage}
          />
        </div>
      </div>
    );
  }
}

TableComponent.propTypes = {
  tableFor: PropTypes.string.isRequired,
  tableData: PropTypes.object.isRequired,
  tableColumns: PropTypes.array.isRequired,
  paginationOptions: PropTypes.object.isRequired,
  selectedFiltersFields: PropTypes.array.isRequired,
  sortingOptions: PropTypes.object.isRequired,
  onChangePagination: PropTypes.func,
  handleChangeColumnSort: PropTypes.func
};

export default TableComponent;
